import { render, staticRenderFns } from "./RegularOrderList.vue?vue&type=template&id=a97a7720&scoped=true&"
import script from "./RegularOrderList.vue?vue&type=script&lang=js&"
export * from "./RegularOrderList.vue?vue&type=script&lang=js&"
import style0 from "./RegularOrderList.vue?vue&type=style&index=0&id=a97a7720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97a7720",
  null
  
)

export default component.exports